// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"30559a91","92":"5b599d55","453":"cb845ceb","556":"07b26ae4","621":"ad7d2f62"}[chunkId] + ".chunk.js";
};